import { Component, OnInit, EventEmitter, Output, Input } from '@angular/core';
import { Agent } from '../../classes/agent';
import { Pagination } from '../../classes/pagination';


// TODO: can this just be turned into the gallery
@Component({
  selector: 'app-agent-list',
  templateUrl: './agent-list.component.html',
  styleUrls: ['./agent-list.component.scss']
})
export class AgentListComponent implements OnInit {
  @Input() readonly agents: Agent[] = [];
  // TODO: should only be readonly?

  @Input() pagination: Pagination;
  @Output() onPaginationChange: EventEmitter<Pagination> = new EventEmitter();
  @Output() onAgentEmailClicked: EventEmitter<Agent> = new EventEmitter();

  Agent = Agent;
  constructor() { }

  ngOnInit() {}

  changePage(newPageNumber: number) {
    this.pagination.pageNumber = newPageNumber;
    this.onPaginationChange.emit(this.pagination);
  }

}
